/**
 * xxx機能定義ファイル
 * 概要
 * 更新履歴
 */

export const sampleStatusId = 'Status';

/** 詳細の初期表示アクション **/
export const sampleInitialAction = 'UpdateItem';
export const sampleDetailInitAction = 'UpdateItem';

/** 案件情報検索サービス種別：汎用トラン 一覧表示テーブルカラム */
export const ColumnListAll:Array<{[k:string]: string | number}> = [
  { name: 'detail', text: '詳細', value: 'detail', order: 0, width: 10},
  { name: 'project_name', text: '案件名', value: 'project_name', order: 1},
  { name: 'Status', text: '案件ステータス', value: 'Status', order: 2},
  { name: 'customer_id', text: '顧客名', value: 'customer_id', order: 3},
  { name: 'department_billing_address_id', text: '顧客部署（請求先）', value: 'department_billing_address_id', order: 4},
  { name: 'department_delivery_destination_id', text: '顧客部署（納入先）', value: 'department_delivery_destination_id', order: 5},
  { name: 'manager_id', text: '案件担当者', order: 6},
  { name: 'billing_payment_information', order: 7},
  { name: 'installation_address', order: 8},
  { name: 'service_type_commodity_id', order: 9},
  { name: 'payment_information', text: '支払情報', value: 'payment_information', order: 10},
  { name: 'estimated_amount', order: 11},
];

/** 案件情報検索サービス種別：OA機器 一覧表示テーブルカラム */
export const ColumnListOA:Array<{[k:string]: string | number}> = [
  { name: 'detail', text: '詳細', value: 'detail', order: 0, width: 10},
  { name: 'project_name', text: '案件名', value: 'project_name', order: 1},
  { name: 'Status', text: '案件ステータス', value: 'Status', order: 2},
  { name: 'customer_id', text: '顧客名', value: 'customer_id', order: 3},
  { name: 'department_billing_address_id', text: '顧客部署（請求先）', value: 'department_billing_address_id', order: 4},
  { name: 'department_delivery_destination_id', text: '顧客部署（納入先）', value: 'department_delivery_destination_id', order: 5},
  { name: 'manager_id', text: '案件担当者', value: 'manager_id', order: 6, width:50},
  { name: 'billing_payment_information', text: '請求先支払情報', value: 'billing_payment_information', order: 7},
  { name: 'installation_address', text: '設置先住所', value: 'installation_address', order: 8},
  { name: 'payment_information', text: '支払情報', value: 'payment_information', order: 9},
  { name: 'credit_status', text: '与信ステータス', value: 'credit_status', order: 10},
  { name: 'true_status', text: '本信ステータス', value: 'true_status', order: 11},
  { name: 'leasing_company_id', text: 'リース会社（本信）', value: 'leasing_company_id', order: 12},
  { name: 'approval_number', text: '承認番号', value: 'approval_number', order: 13},
  { name: 'special_notes', text: '特記事項', value: 'special_notes', order: 14},
  { name: 'estimated_amount', order: 15},
  { name: 'final_rate', text: '最終料率', value: 'final_rate', order: 16},
  { name: 'contract_month', text: '契約月数', value: 'contract_month', order: 17},
  { name: 'monthly_lease_fee', text: '月額リース料', value: 'monthly_lease_fee', order: 18},
];

/** 案件情報検索サービス種別：F-Japan 一覧表示テーブルカラム */
export const ColumnListFJapan:Array<{[k:string]: string | number}> = [
  { name: 'detail', text: '詳細', value: 'detail', order: 0, width: 10},
  { name: 'project_name', text: '案件名', value: 'project_name', order: 1},
  { name: 'Status', text: '案件ステータス', value: 'Status', order: 2},
  { name: 'customer_id', text: '顧客名', value: 'customer_id', order: 3},
  { name: 'department_billing_address_id', text: '顧客部署（請求先）', value: 'department_billing_address_id', order: 4},
  { name: 'department_delivery_destination_id', text: '顧客部署（納入先）', value: 'department_delivery_destination_id', order: 5},
  { name: 'manager_id', text: '案件担当者', order: 6},
  { name: 'installation_address', order: 7},
  { name: 'service_type_commodity_id', order: 8},
  { name: 'payment_information', text: '支払情報', value: 'payment_information', order: 9},
  { name: 'estimated_amount', order: 10}
];

/** 検索パネルのGrid1区間の横幅（%） */
export const SearchPanelColumnWidth = 5;

/** 登録ガイドメッセージ */
export const authorityValidMessage = 'この内容でよろしければ「登録する」を押してください';
export const authorityInvalidMessage = '登録権限を持たないユーザです';

/** 登録・編集完了時の確認ダイアログ */
export const registerFinishText = '登録が完了いたしました';
export const registerFinishAction = [
  {
    id: 1,
    color: 'primary',
    type: 'routing',
    name: 'toEdit',
    value: '詳細画面へ',
    route: '/sample/edit/:id'
  }
];
export const editFinishText = 'xxx情報を編集しました';
export const editFinishAction = [
  {
    id: 1,
    color: 'primary',
    type: 'reload',
    name: 'reload',
    value: '閉じる',
  }
];
// 自動採番APIの格納フィールドIDと採番フィールドID
// eslint-disable-next-line @typescript-eslint/no-namespace
namespace autoNumber {
  export const Define: { [k: string]: {[k: string]: string} } = {
    appNumber: {
      displayId: 'sample_application_no',
      autoFieldId: '_autonum_sample_application_no',
      linkDsFieldId: 'sample_application_no'
    },
    sampleNumber: {
      displayId: 'sample_no',
      autoFieldId: '_autonum_sample_no',
      linkDsFieldId: 'sample_no'
    }
  }
}
export const AutoNumberDefine = autoNumber.Define;

//検索時の初期表示Option
export const StatusSelectInitialOption: {text: string, value: string[]} = {text: '全ステータス', value: []};
export const DetailNotFoundMessage = '明細情報はありませんでした';


export const filterSelect = [
  {key: 'supplier_id', target: 'supplier_staff_id'},
  {key: 'payment_destination_supplier_id', target: 'payment_information_id'},
  {key: 'item_id', target: 'standard_name', isDetail: true}
]

// 検索時除外するステータス
export const ProjectSearchExclusionStatus = [
  '削除済'
];